import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    date_available: { isoDate: true }
  })
}